import { useCallback, useRef } from "react";

const ViewStep = ({ step }) => {
  const timeoutRef = useRef(null);

  const handleClick = useCallback((e) => {
    const container = e.currentTarget;
    const copyableSpan = e.target.closest(".copyable");

    if (!copyableSpan || !container.contains(copyableSpan)) return;
    if (copyableSpan.classList.contains("copying")) return;

    copyableSpan.classList.add("copying");
    e.stopPropagation();

    let textToCopy = copyableSpan.textContent || "";
    textToCopy = textToCopy.replace(/\s+/g, " ").trim();

    if (!textToCopy) {
      copyableSpan.classList.remove("copying");
      return;
    }

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    container.querySelectorAll(".copyable.copied").forEach((el) =>
      el.classList.remove("copied")
    );

    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        copyableSpan.classList.remove("copying");
        copyableSpan.classList.add("copied");

        timeoutRef.current = setTimeout(() => {
          copyableSpan.classList.remove("copied");
          timeoutRef.current = null;
        }, 500);
      })
      .catch(() => {
        copyableSpan.classList.remove("copying");
        alert("Copy failed!");
      });
  }, []);

  return (
    <div
      className="mb-2 step-view"
      onClick={handleClick}
      dangerouslySetInnerHTML={{ __html: step }}
    />
  );
};

export default ViewStep;
